import { Fragment, useEffect, useState } from 'react';
import { getLocale, sendGAEvent, convertValueToIntegers } from '!/common/helpers';


const Ranges = props => {
  const { name, aggs, values, total, update } = props;
  const options = aggs[name] || [];

  const [activeOptions, setActiveOptions] = useState(values[name]);

  useEffect(() => {
    setActiveOptions(values[name]);
  }, [values, name]);

  const onChange = ({ target }) => {
    const label = `{"value": "${target.value}", "section": "${name}"}`;
    sendGAEvent('Search Filter', 'filter switched', label);
    update(name, target.value === "" ? [] : [target.value]);
  };

  if (name == "averageRating") {
    var label = getLocale('All Products');
    options.forEach(option => {
      const optionValues = convertValueToIntegers(option.value);
      option.label = <>
        <span className="rating__stars">
            <span className="rating__stars-value" style={{width: optionValues[0]*20 + "%"}}></span>
        </span>
        <span>
          {
            `${optionValues[0]} ${getLocale('& above')} `
          }
          &nbsp;
          <small>({option.count})</small>
        </span>
      </>;
    });

  } else {
    // assume price range
    var label = getLocale('All Prices');
    options.forEach(option => {
      const optionValues = convertValueToIntegers(option.value);
      const currency = option['currency'] || '€';
      option.label = <span>
        {
          optionValues.length > 1 ? `${getLocale(currency)} ${optionValues.join('-')}` : `${getLocale('Above ')}${getLocale(currency)} ${optionValues.join('-')}`
        }
        &nbsp;
        <small>({option.count})</small>
      </span>;
    });
  }

  return (
    <Fragment>
      <label className="input-radio">
        <input type="radio" name={name} value={''} onChange={onChange} checked={typeof activeOptions === 'undefined' || activeOptions?.length === 0} />
        <span>
          {label}
          &nbsp;
          <small>({total})</small>
        </span>
      </label>

      {options.map((option, index) => {
        const optionValues = convertValueToIntegers(option.value);
        const value = optionValues.join('-');

        if (option.count > 0) {
          return (
            <label key={index} className="input-radio">
              <input
                type="radio"
                name={name}
                key={index}
                value={value}
                onChange={onChange}
                checked={typeof activeOptions !== 'undefined' && activeOptions?.includes(value)}
              />
              {option.label}
            </label>
          );
        }
      })}
    </Fragment>
  );
};

export default Ranges;
